module.exports = __webpack_public_path__ + "img/cover.7352c60e.png";